import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/axiosInstance";

export const deleteCurrencyFunc = createAsyncThunk(
  "deleteCurrency",
  async (id, thunkAPI) => {
    try {
      const response = await api.delete(`dashboard/currencies/${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

const deleteCurrencySlicer = createSlice({
  name: "deleteCurrency",
  initialState: {
    loading: false,
    data: [],
    error: null,
    apiErrors: {},
    successMessage: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteCurrencyFunc.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.apiErrors = {};
      })
      .addCase(deleteCurrencyFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.successMessage = action.payload?.message || "";
      })
      .addCase(deleteCurrencyFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.apiErrors = action.payload?.errors || {};
      });
  },
});

export default deleteCurrencySlicer.reducer;
